import { DateTime } from 'luxon';

// get a timestamp in EST with optional starting date
export const getEstTimestamp = (dateString?: string): number => {
  if (dateString) {
    return DateTime.fromFormat(dateString, 'yyyy-MM-dd HH:mm:ss', { zone: 'America/New_York' }).toMillis();
  } else {
    return DateTime.now().setZone('America/New_York').toMillis();
  }
};
